<template>
  <el-table-column
    prop="description"
    sortable="custom"
    label="Leírás"
    show-overflow-tooltip
    min-width="90"
  >
    <template slot-scope="scope">
      {{ scope.row.description || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'description',
  };
</script>
